module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Get Paid More and Promoted Faster")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "CSS_1.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "d14e289"
    }
  }, [_c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_18"
    }
  }, [_c('span', {
    attrs: {
      "id": "d14e292"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "d7e94918"
    }
  }, [_c('b', [_vm._v("1 ")]), _c('br'), _c('b', [_vm._v("Decide Exactly ")]), _c('br'), _c('b', [_vm._v("What You Want ")])]), _vm._v(" "), _c('div', {
    staticClass: "cite"
  }, [_c('p', {
    staticClass: "blockquote",
    attrs: {
      "id": "d14e304"
    }
  }, [_c('span', [_vm._v("The world has a habit of making room for the man whose words and actions show that he knows where he is going.")])]), _c('p', {
    attrs: {
      "id": "d14e306"
    }
  }, [_c('span', [_vm._v("—N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APOLEON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL")])])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e99118"
    }
  }, [_vm._v("This is the “giant step” in personal success and achievement. Decide what you really want from your career. Take the time to analyze your personal talents and abilities. Look deep into yourself to determine what you really enjoy doing. Identify the tasks and activities that most interest you and hold your attention. Think back over your past jobs. What have been your most satisfying experiences and your most enjoyable moments?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e102318"
    }
  }, [_vm._v("You are nature’s greatest miracle. You are the end result of millions of years of evolution. There never has been, nor ever will be, anyone exactly like you. In your genetic code, you have been programmed with  remarkable potential abilities that you can develop to perform certain tasks extraordinarily well.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_19"
    }
  }, [_c('span', {
    attrs: {
      "id": "d14e318"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e105019"
    }
  }, [_vm._v("You have been engineered for success from birth. You have within you deep reservoirs of talent and potential skill that you have not yet tapped into. You have the capacity to be, do, and have virtually anything that you put your mind to. But you must first accept the responsibility of deciding exactly what you really want and then dedicate yourself wholeheartedly to becoming everything you are capable of becoming.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e107919"
    }
  }, [_vm._v("In deciding what you really want, practice the process of "), _c('i', [_vm._v("idealization ")]), _vm._v("in your career. Project yourself forward five years and imagine that you were doing the ideal job, with the ideal people, at the ideal salary, and under the ideal conditions. What would it look like? Define your ideal clearly and then determine what you would have to do, starting today, to make it a reality.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e111319"
    }
  }, [_vm._v("Imagine for a moment that you could have any job at all. Imagine that all jobs and positions are open to you. Imagine that there is a job that you would really enjoy doing, hour after hour and day after day.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e112919"
    }
  }, [_vm._v("One of the greatest of all success secrets is for you to decide what you really enjoy doing and then find a way to make a good living doing just that. And this is up to you. No one else can do it for you. You are responsible. ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e114319"
    }
  }, [_vm._v("You will almost always be paid more and promoted faster when you are doing something that you  enjoy, something that you find interesting and challenging and that stimulates and motivates you. The fact is that unless you really enjoy your work, you will never be able to develop the commitment, enthusiasm, and dedication necessary to rise above and push through the difficulties, challenges, and setbacks that every job or career contains.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_20"
    }
  }, [_c('span', {
    attrs: {
      "id": "d14e335"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e118020"
    }
  }, [_vm._v("To clarify your thinking, practice "), _c('i', [_vm._v("zero-based thinking ")]), _vm._v("regularly in your career and in your personal life. This method of analysis is a key thinking skill that comes from zero-based accounting and is one of the most powerful thinking techniques that you can learn and practice.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e120720"
    }
  }, [_vm._v("The way it works is simple. In zero-based accounting, you look at every expense and ask, “If we were not now engaged in this expenditure, knowing what we now know, would we begin it again today?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e122320"
    }
  }, [_vm._v("Zero-based thinking is similar. Consider all of your previous decisions and ask yourself this question: “Is there anything in my life that I am doing today that, knowing what I now know, I wouldn’t get into again today if I had to do it over?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e124220"
    }
  }, [_vm._v("This is one of the most helpful questions you can ever ask and answer. "), _c('i', [_vm._v("Is there anything in your life that ")]), _c('i', [_vm._v("you are doing today that, knowing what you now know, ")]), _c('i', [_vm._v("you wouldn’t get into again today if you had to do it ")]), _c('i', [_vm._v("over?")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e126520"
    }
  }, [_vm._v("The fact is that in times of turbulence and rapid change such as today, and probably for the rest of  your career, you will always be able to say yes to that question regarding some area of your life or work.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_21"
    }
  }, [_c('span', {
    attrs: {
      "id": "d14e359"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e128621"
    }
  }, [_vm._v("Apply zero-based thinking to your current job. Knowing what you now know, would you take this job again on the same terms and conditions that you are now working under? Would you take this job working for this particular boss? Would you go to work for this company? In this industry? At this salary? Or in this position? Yes or no?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e131621"
    }
  }, [_vm._v("If the answer is no, your next question is, “How do I change this situation, and how fast can I do it?” You are responsible.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e132921"
    }
  }, [_vm._v("You may have to invest a lot of effort and make a lot of false starts before your ideal career. But it all begins with your sitting down and deciding what you really want in a job, as well as what you don’t want, and then taking action to achieve that goal.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_22"
    }
  }, [_c('span', {
    attrs: {
      "id": "d14e371"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "d7e135222"
    }
  }, [_c('b', [_vm._v("TAKE ACTION NOW!")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e135922"
    }
  }, [_vm._v("Make up a “dream list” for your ideal job or position. Begin by imagining that you have no limitations on what you could do. Imagine that all possibilities are open to you. Imagine that you have all the education, all the knowledge, all the experience, all the contacts, and all the time and money you need. What job would you choose if you could have any job at all?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e139622"
    }
  }, [_vm._v("Think in terms of specific actions that you could take immediately. What could you do right now to begin preparing yourself and moving toward the exact job or position you really want? Whatever your answer, do something, do anything, but get started. You are responsible.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40a438f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 78
// module chunks = 0